import { logError } from "@version.compare/bandit/src/utils";

declare global {
  interface Window {
    vcSiteId?: string;
  }
}

export function populateSiteId() {
  const currentScript =
    document.currentScript ||
    (function () {
      let scripts = document.getElementsByTagName("script");
      return scripts[scripts.length - 1];
    })();


  const siteId = currentScript.dataset.siteid;

  if (!siteId) {
    logError("No siteId provided. Version Compare won't operate. Please add a site id using the data attribute 'data-siteid'");
    throw new Error("Version.Compare: Missing siteId");
  }

  window.vcSiteId = siteId;
  document.dispatchEvent(new CustomEvent("vcSiteIdReady", { detail: window.vcSiteId }));
}

export function getSiteId() {
  return window.vcSiteId;
}